export default class License {
  constructor(API) {
    this.api = API;
  }
  async assignLicense(externalID, assignedTo, body) {
    const req = await this.api.newBaseRequest("POST");
    req.path = "/license/" + externalID + "/assign/" + assignedTo;
    req.body = { ...body };
    return await req.exec();
  }
  async unassignLicense(externalID, activationKey) {
    const req = await this.api.newBaseRequest("POST");
    req.path = "/license/" + externalID + "/unassign/" + activationKey;
    return await req.exec();
  }
  async assignLicenseCount(externalID, licenseID, body) {
    const req = await this.api.newBaseRequest("PUT");
    req.path = "/license/" + externalID + "/adjust/" + licenseID;
    req.body = { ...body };
    return await req.exec();
  }
  async redeemLicenseByProduct(productID, externalID, sessionID) {
    const req = await this.api.newBaseRequest("POST");
    req.path = "/license/redeem/available";
    req.body = { productID, externalID, sessionID };
    return await req.exec();
  }
  async redeemLicense(
    activationCode,
    productID,
    externalID,
    referralID,
    sessionID
  ) {
    const req = await this.api.newBaseRequest("POST");
    req.path = "/license/redeem";
    req.body = {
      key: activationCode,
      productID,
      externalID,
      referralID,
      sessionID,
    };
    return await req.exec();
  }
  async revokeLicense(licenseID) {
    const req = await this.api.newBaseRequest("POST");
    req.path = "/license/" + licenseID + "/revoke";
    return await req.exec();
  }
  async revokeLicenseActivations(licenseID, numActivations) {
    const req = await this.api.newBaseRequest("POST");
    req.path = `/license/${licenseID}/revoke/${numActivations}`;
    return await req.exec();
  }
  async revokeLicenses(licenseIDs) {
    const req = await this.api.newBaseRequest("POST");
    req.path = "/license/revoke/bulk";
    req.body = { licenseIDs };
    return await req.exec();
  }
  async getLicenseByID(licenseID) {
    const req = await this.api.newBaseRequest("GET");
    req.path = `/license/${licenseID}`;
    return await req.exec();
  }
  async updateLicenseByID(licenseID, licenseProps) {
    const req = await this.api.newBaseRequest("PUT");
    req.path = `/license/${licenseID}`;
    req.body = { ...licenseProps };
    return await req.exec();
  }
  async getLicense(licenseID, externalID) {
    const req = await this.api.newBaseRequest("GET");
    req.path = "/license/" + licenseID + "/" + externalID;
    return await req.exec();
  }
  async getLicensesByExternalID(externalID) {
    const req = await this.api.newBaseRequest("GET");
    req.path = "/licenses/" + externalID;
    return await req.exec();
  }
  async getLicensesByExternalIDs(externalIDs) {
    const req = await this.api.newBaseRequest("POST");
    req.path = "/licenses/byIDs";
    req.body = { IDs: externalIDs };
    return await req.exec();
  }
  async getAvailableLicensesByExternalAndProductIDs(
    extID,
    productID,
    expanded = false
  ) {
    const req = await this.api.newBaseRequest("GET");
    req.path =
      `/licenses/${extID}/product/${productID}/available` +
      (expanded ? "?expanded=true" : "");
    return await req.exec();
  }
  async transferOrgLicenses(sourceOrg, targetOrg) {
    const req = await this.api.newBaseRequest("POST");
    req.path = "/licenses/transfer";
    req.body = { sourceOrg, targetOrg };
    return await req.exec();
  }
}
